import { render, staticRenderFns } from "./ClientNewLoan.vue?vue&type=template&id=3ad1dd10&scoped=true&"
import script from "./ClientNewLoan.vue?vue&type=script&lang=js&"
export * from "./ClientNewLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad1dd10",
  null
  
)

export default component.exports